import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
// import OfferPageModel from 'models/OfferPage';
import PageTransition from 'containers/PageTransition';
import Head from 'components/Head';
import SlidingPageTransition from 'components/SlidingPageTransition';

import Link from 'next/link';
import ContentWrapper from './styled/ContentWrapper.js';
import Background from './styled/Background';
import BurgerMenu from './styled/BurgerMenu';
import BurgerButton from './styled/BurgerButton';
import HomeButton from './styled/HomeButton';
import SecondaryFooter from './styled/SecondaryFooter';
import OfferSection from './components/OfferSection';
import Wrapper from './styled/Wrapper.js';

export default class OfferPage extends PureComponent {

  static contextType = ThemeContext;

  state = {
    isMenuVisible: false,
    isTopVisible: false,
  };

  onBurgerClick = () => {
    const { isMenuVisible } = this.state;
    this.setState({ isMenuVisible: !isMenuVisible });
    // if(appState.analytics)appState.analytics._trackEvent('OfferPage', 'click burger');
  };

  onTopButtonClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // if(appState.analytics)appState.analytics._trackEvent('OfferPage', 'click top');
  };

  render() {
    const { router, ogTags, req, navLinks, offerTypes, offerLinkPrev, offerLinkNext } = this.props;
    const { isMenuVisible } = this.state;

    return (
      <>
        <Head ogTags={ogTags} router={router} />
        {/* <PageTransition router={router} component={SlidingPageTransition}> */}
          <Wrapper theme={this.context}>
            <ContentWrapper hidden={isMenuVisible}>
              <Background blank dark />
              <OfferSection offerTypes={offerTypes} />
              <Link href="/" passHref>
                <HomeButton />
              </Link>
              <SecondaryFooter
                nextLink={offerLinkNext}
                prevLink={offerLinkPrev}
                onTopButtonClick={this.onTopButtonClick}
                dark={true}
              />
            </ContentWrapper>
            <BurgerMenu router={router} items={navLinks} light={false} hidden={!isMenuVisible} />
            <BurgerButton isActive={isMenuVisible} light={false} onClick={this.onBurgerClick} />
          </Wrapper>
        {/* </PageTransition> */}
      </>
    );
  }
}
